{
	"appliedToSuggestedMessage": "This image is now automatically applied to all the suggested photos. You can disable this in Settings.",
	"appliedToSuggestedTitle": "Color match is applied to all the suggested photos",
	"applyCurrentImage": "Apply Current Image",
	"ariaAddColorMatchImage": "Add Color Match Image",
	"ariaApplyCurrentColorMatchImage": "Apply Current Color Match Image",
	"ariaBrowseColorMatchPresets": "Browse Color Match Presets",
	"ariaColorMatchPresetMenu": "Color Match Preset Menu",
	"ariaDeleteColorMatchImage": "Delete Color Match Image",
	"ariaImportColorMatchImage": "Import Color Match Image",
	"ariaNextColorMatchImage": "Next Color Match Image",
	"ariaPreviousColorMatchImage": "Previous Color Match Image",
	"ariaSelectColorMatchImage": "Select Color Match Image",
	"ariaToggleColorMatchOutputParameters": "Toggle Color Match Output Parameters",
	"ariaToggleColorMatchSkinToneOptimization": "Toggle Color Match Skin Tone Optimization",
	"browseSamples": "Browse samples",
	"chooseSourceImage": "Choose Source Image",
	"continue": "Continue",
	"importYourOwn": "Import your own",
	"openSettings": "Open Settings",
	"optimizeForSkinTone": "Optimize For Skin Tone",
	"outputParameters": "Output Parameters",
	"panelColorMatch": "Color Match",
	"sampleAdd": "Add",
	"sampleAdded": "Added",
	"sampleCategoryAll": "All",
	"sampleCategoryFilm": "Film",
	"sampleCategoryWedding": "Wedding",
	"pleaseSelectJpegPngWebp": "Please select JPEG, PNG, WEBP, AVIF, HEIC files.",
	"retryColorMatchImageUpload": "Retry Color Match Image Upload",
	"retryUpload": "Retry upload",
	"sliderStrength": "Strength"
}
